import React, { useEffect, useState } from "react";
import styles from "./CartInformationForm.module.css";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchListCityRequest,
  fetchListDistrictRequest,
  fetchListWardRequest,
} from "redux/ActionCreators/AddressActionCreators";
import { Grid } from "@material-ui/core";
import { FastField, Field, Form, Formik } from "formik";
import InputFiled from "shared/components/InputField/index";
import SelectFiled from "shared/components/SelectField/index";
import * as Yup from "yup";
import {
  ERROR_MESSAGE,
  LOCAL_STORAGE_INFORMATION_CART,
} from "shared/Constants";
import { Button } from "@material-ui/core";
import { PAYMENT_METHOD } from "../../../shared/Constants";
import RadioFiled from "../../../shared/components/RadioFeild/index";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";

const CartInformationForm = (props) => {
  const { handelDataSubmit } = props;
  const dispatch = useDispatch();

  const cities = useSelector((state) => state.address.cities);
  const districts = useSelector((state) => state.address.districts);
  const wards = useSelector((state) => state.address.wards);

  const [initialValues, setInitialValues] = useState(
    getInitialValues(
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_INFORMATION_CART))
    )
  );

  useEffect(() => {
    if (!initialValues) {
      history.push(RouterName.Payment.Cart.url);
    }

    dispatch(fetchListCityRequest());

    if (initialValues.district) {
      handleChangeCity(initialValues.city);
      if (initialValues.ward) {
        handleChangeDistrict(initialValues.district);
      }
    }
  }, []);

  const handleChangeCity = (data) => {
    dispatch(fetchListDistrictRequest(data));
  };

  const handleChangeDistrict = (data) => {
    dispatch(fetchListWardRequest(data));
  };

  const handleSubmit = (data) => {
    data.city = { ...cities.find((item) => item.value === data.city) };
    data.district = {
      ...districts.find((item) => item.value === data.district),
    };
    data.ward = { ...wards.find((item) => item.value === data.ward) };

    handelDataSubmit(data);
  };

  return (
    <div className={styles.container}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          return (
            <Form className={styles.content}>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FastField
                      name="firstName"
                      component={InputFiled}
                      label="Tên"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FastField
                      name="lastName"
                      component={InputFiled}
                      label="Họ"
                    />
                  </Grid>
                </Grid>
              </div>

              <div className={styles.item}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FastField
                      name="email"
                      component={InputFiled}
                      label="Email"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FastField
                      name="phoneNumber"
                      component={InputFiled}
                      label="Số Điện Thoại"
                    />
                  </Grid>
                </Grid>
              </div>
              <div className={styles.item}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Field
                      name="city"
                      component={SelectFiled}
                      label="Tỉnh/Thành Phố"
                      options={cities}
                      handleData={handleChangeCity}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Field
                      name="district"
                      component={SelectFiled}
                      label="Huyện/Thị Trấn"
                      options={districts}
                      handleData={handleChangeDistrict}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Field
                      name="ward"
                      component={SelectFiled}
                      label="Xã"
                      options={wards}
                    />
                  </Grid>
                </Grid>
              </div>

              <div className={styles.item}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <FastField
                      name="addressDetail"
                      component={InputFiled}
                      label="Địa chỉ chi tiết"
                    />
                  </Grid>
                </Grid>
              </div>

              <div className={styles.item}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <FastField
                      name="paymentMethod"
                      component={RadioFiled}
                      label="Hình Thức Thanh Toán"
                      options={PAYMENT_METHOD.map((item) => {
                        if (item.key === "PAYMENT_METHOD_OFFICE") {
                          return {
                            value: item.key,
                            name: item.name,
                            disabled: false,
                          };
                        } else {
                          return {
                            value: item.key,
                            name: `${item.name} (hiện chức năng đang được phát triển)`,
                            disabled: true,
                          };
                        }
                      })}
                    />
                  </Grid>
                </Grid>
              </div>

              <div className={styles.btn_submit}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                >
                  Hoàn thành thông tin
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const getInitialValues = (data) => {
  if (data) {
    data.city = data.city.value;
    data.district = data.district.value;
    data.ward = data.ward.value;

    return { ...data };
  }
  return {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    addressDetail: "",
    city: "",
    district: "",
    ward: "",
    paymentMethod: "PAYMENT_METHOD_OFFICE",
  };
};

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  lastName: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  email: Yup.string()
    .required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED)
    .email(ERROR_MESSAGE.TEXT_FIELD_EMAIL),
  addressDetail: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  phoneNumber: Yup.string()
    .required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED)
    .matches(
      /(03|07|08|09|01[2|6|8|9])+([0-9]{8})\b/,
      ERROR_MESSAGE.TEXT_FIELD_PHONE_NUMBER
    ),
  city: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  district: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  ward: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  paymentMethod: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
});

export default CartInformationForm;
